module.exports = __webpack_public_path__ + "images/marketing/integrations/quickbooks_connect_white.png";